/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import * as actions from '../../types/user-action.type';

export const getUserLicenses = () => ({
  type: actions.GET_USER_LICENSES,
  payload: null,
});

export const getUserLicensesError = (data:any) => ({
  type: actions.GET_USER_LICENSES_ERROR,
  payload: data,
});

export const getUserLicensesSuccess = (data:any) => ({
  type: actions.GET_USER_LICENSES_SUCCESS,
  payload: data,
});

export const getUserInfo = () => ({
  type: actions.GET_USER_INFO,
  payload: null,
});

export const getUserInfoError = (data:any) => ({
  type: actions.GET_USER_INFO_ERROR,
  payload: data,
});

export const getUserInfoSuccess = (data:any) => ({
  type: actions.GET_USER_INFO_SUCCESS,
  payload: data,
});
